import type { Resource } from '../../';
export const country_countries_MC: Resource = {"default":"Monaco"};
